import React, { useContext } from "react";
import { useParams } from "react-router-dom";

import { InitiativesLayout } from "../../../organisms/Layouts";
import { H3, P } from "../../../atoms/Texts";
import { InitiativeOptCard } from "../../../atoms/Cards";

import notSearchedImg from "../../../../assets/images/Curly Arrow.svg";

import { demoContext } from "../../../../shared/store/contexts";

const InitiativeOptIn = () => {
  const { id: orgId } = useParams();

  const { requests } = useContext(demoContext);
  return (
    <InitiativesLayout>
      <div>
        {requests?.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {requests?.map((item) => (
              <InitiativeOptCard
                orgId={orgId}
                key={item.id}
                request={item}
                type="sent"
              />
            ))}
          </div>
        ) : (
          <>
            <div className="flex flex-col items-center flex-grow justify-center">
              <img src={notSearchedImg} alt="" className="" />
              <H3
                color="#22202D"
                className="mt-6 text-center"
                data-testid="eligibility-text"
              >
                You have not sent an opt-in request.
              </H3>
              <P fontSize="16px" color="#7D7B96" className="mt-3 mb-0 text-center">
                Search for the initiative to join.
              </P>
            </div>
          </>
        )}
      </div>
    </InitiativesLayout>
  );
};

export default InitiativeOptIn;
